import { render, staticRenderFns } from "./SaleProductAmount.vue?vue&type=template&id=4e2c09fc&scoped=true&"
import script from "./SaleProductAmount.vue?vue&type=script&lang=js&"
export * from "./SaleProductAmount.vue?vue&type=script&lang=js&"
import style0 from "./SaleProductAmount.vue?vue&type=style&index=0&id=4e2c09fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c09fc",
  null
  
)

export default component.exports